import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  CircularProgress,
  IconButton,
} from "@mui/material";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const CameraDialog = ({
  open,
  onClose,
  cameraError,
  cameraScanResult,
  videoRef,
  onGalleryClick,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullScreen
    PaperProps={{ sx: { bgcolor: "#000", direction: "ltr" } }}
  >
    <DialogTitle
      sx={{
        color: "#fff",
        bgcolor: "#0563B0",
        fontWeight: 700,
        fontSize: "1.05rem",
        display: "flex",
        alignItems: "center",
        gap: 1,
        py: 1.5,
      }}
    >
      <PhotoCameraIcon sx={{ fontSize: 22 }} />
      סרוק קוד QR עם המצלמה
      <IconButton
        onClick={onGalleryClick}
        sx={{ ml: "auto", color: "rgba(255,255,255,0.85)" }}
        size="small"
        title="גלריה"
      >
        <ImageIcon />
      </IconButton>
      <Button
        onClick={onClose}
        size="small"
        startIcon={<CloseIcon />}
        sx={{
          ml: 0.5,
          color: "#fff",
          fontSize: "0.8rem",
          fontWeight: 600,
          textTransform: "none",
          bgcolor: "rgba(255,255,255,0.15)",
          borderRadius: 2,
          px: 1.2,
          "&:hover": { bgcolor: "rgba(255,255,255,0.25)" },
        }}
      >
        סיום סריקה
      </Button>
    </DialogTitle>
    <DialogContent
      sx={{
        p: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#000",
      }}
    >
      {cameraError ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            p: 4,
            textAlign: "center",
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 56, color: "#ff9800" }} />
          <Typography sx={{ color: "#fff", fontSize: "1rem", lineHeight: 1.6 }}>
            {cameraError}
          </Typography>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{ borderRadius: 2, fontWeight: 600, bgcolor: "#0563B0", mt: 1 }}
          >
            סגור
          </Button>
        </Box>
      ) : (
        <>
          <Box sx={{ position: "relative", width: "100%" }}>
            <video
              ref={videoRef}
              style={{
                width: "100%",
                maxHeight: "80dvh",
                objectFit: "cover",
                display: "block",
              }}
              playsInline
              muted
            />
            {cameraScanResult && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  py: 2,
                  px: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.5,
                  bgcolor: cameraScanResult.processing
                    ? "rgba(0,0,0,0.72)"
                    : cameraScanResult.success
                    ? "rgba(27,94,32,0.88)"
                    : "rgba(183,28,28,0.88)",
                }}
              >
                {cameraScanResult.processing ? (
                  <>
                    <CircularProgress size={20} sx={{ color: "#fff" }} />
                    <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>
                      מעבד...
                    </Typography>
                  </>
                ) : cameraScanResult.success ? (
                  <>
                    <CheckCircleOutlineIcon sx={{ color: "#fff", fontSize: 26 }} />
                    <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>
                      נוסף: {cameraScanResult.sernum}
                    </Typography>
                  </>
                ) : (
                  <>
                    <WarningAmberIcon sx={{ color: "#fff", fontSize: 26 }} />
                    <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}>
                      {cameraScanResult.message}
                    </Typography>
                  </>
                )}
              </Box>
            )}
          </Box>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.7)",
              fontSize: "0.85rem",
              mt: 2,
              px: 3,
              textAlign: "center",
            }}
          >
            כוון את המצלמה לעבר קוד ה-QR – הסריקה רציפה
          </Typography>
        </>
      )}
    </DialogContent>
  </Dialog>
);

export default CameraDialog;
